import dayjs from 'dayjs';

const dateFormatAndTime = 'DD/MM/YYYY HH:mm';
const dateFormat = 'DD/MM/YYYY';
const timeFormat = 'HH:mm';

const invalidDateSubstring = '0001-01-01';

export const formatDateAndTime = (
  date: string | null,
  format = dateFormatAndTime,
  returnNA = true
) => {
  if (
    date === null ||
    (typeof date === 'string' && date.includes(invalidDateSubstring))
  ) {
    return returnNA ? 'N/A' : '';
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime()) || parsedDate.getTime() < 0) {
    return returnNA ? 'N/A' : '';
  }

  return dayjs(date).format(format);
};

export const formatDate = (date: string | Date | null, format = dateFormat) => {
  if (date instanceof Date && date?.getTime() < 0) {
    return 'N/A';
  }

  return typeof date === 'string' && date.includes(invalidDateSubstring)
    ? 'N/A'
    : dayjs(date).format(format);
};

export const formatTime = (date: string | null, format = timeFormat) => {
  return typeof date === 'string' && date.includes(invalidDateSubstring)
    ? 'N/A'
    : dayjs(date).format(format);
};

export function getMonthString(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { month: 'long' };
  const formattedMonth = new Intl.DateTimeFormat('en-US', options).format(date);
  return formattedMonth;
}

// Función para obtener el mes actual en inglés
export const getJustMonthFromCurrentDate = (): string => {
  const now = new Date();
  const monthIndex = now.getMonth();

  const monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  return monthNames[monthIndex];
};

export function getMonthStringAndDayNumber(dateString: string): string {
  const date = new Date(dateString);
  const monthOptions: Intl.DateTimeFormatOptions = { month: 'long' };
  const dayOptions: Intl.DateTimeFormatOptions = { day: '2-digit' };

  const formattedMonth = new Intl.DateTimeFormat('en-US', monthOptions).format(
    date
  );
  const formattedDay = new Intl.DateTimeFormat('en-US', dayOptions).format(
    date
  );

  return `${formattedMonth} ${formattedDay}`;
}

export const getMonthAndDayFromCurrentDate = (): string => {
  const now = new Date();
  const monthIndex = now.getMonth();
  const year = now.getFullYear();

  const monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  return `${monthNames[monthIndex - 1]} ${year} `;
};
